import angular from 'angular';

import ContactComponent from './contact/Contact.component';
import ContactListComponent from './contactList/ContactList.component';

export default angular
    .module('app.contact', ['shared'])
    .component('contact', ContactComponent)
    .component('contactList', ContactListComponent).name;
